import { useRef, useEffect, useState } from "react";

export function useCapacityExcelExport(weekStart: string, productFilters = { mainGroup: "", subGroup: "", subdivision: "" }) {
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef<AbortController | null>(null);
  useEffect(() => () => pending.current?.abort(), []);
  const download = async () => {
    if (pending.current) return;
    const controller = new AbortController(); pending.current = controller;
    setExporting(true); setError("");
    try {
      const query = new URLSearchParams({ weekStart, ...Object.fromEntries(Object.entries(productFilters).filter(([, value]) => value)) });
      const response = await fetch(`/api/sarf39/manual-packaging/capacity.xlsx?${query}`, {
        credentials: "same-origin", cache: "no-store", signal: controller.signal,
      });
      if (!response.ok || !response.headers.get("content-type")?.includes("spreadsheetml")) throw new Error("Excel raporu alınamadı. Mikro bağlantısını kontrol edip yeniden deneyin.");
      const url = URL.createObjectURL(await response.blob());
      const link = document.createElement("a"); link.href = url; link.download = `ANL-hat-cizelgesi-${weekStart}.xlsx`;
      link.click(); window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (reason) { if (!controller.signal.aborted) setError(reason instanceof Error ? reason.message : "Excel indirilemedi."); }
    finally { pending.current = null; if (!controller.signal.aborted) setExporting(false); }
  };
  return { download, exporting, error };
}
